module.exports = __webpack_public_path__ + "static/media/dg.eef31d33.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/dg.png
// module id = 718
// module chunks = 0